// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#renderCanvas{transition:-webkit-filter 1s ease;transition:filter 1s ease;transition:filter 1s ease,-webkit-filter 1s ease;outline:none}", ""]);
// Exports
module.exports = exports;
